import { defineStore } from 'pinia';
import FormulaApi from '@/api/formula-api';
import GlobalRequest from '@/api/global-request';
import { showToast } from '@/helpers/toast-handler';
import { getPage, getPerPage } from '@/composables/PaginationComposable';

const FORMULA_URL = 'v2/template/formulas';

export const useFormulaStore = defineStore('formula', {
    state: () => ({
        formula: {},
        formulas: [],
        totalFormulas: 0,
    }),
    actions: {
        async fetchAllFormulas(company_id, pageable, list) {

            if (typeof pageable === 'undefined' || pageable === null) {
                pageable = false
            }

            let page_size = 0
            let page = 0

            if (typeof list !== 'undefined') {
                page_size = getPerPage(list)
                page = getPage(list) + 1
            }

            try {
                const response = await GlobalRequest.getRequest(FORMULA_URL, {
                    params: {
                        company_id: company_id,
                        paginate: pageable,
                        page_size: page_size,
                        page: page,
                    },
                });

                if (pageable) {
                    this.totalFormulas = response.data.total;
                    this.formulas = response.data.data;
                } else {
                    this.formulas = response.data;
                }

            } catch (error) {
                showToast(error.response || error, 'Failed to fetch all the formulas');
            }
        },

        async createFormula(body) {
            try {
                const response = await FormulaApi.addFormula(body);
                if (response.message == 'Ok') showToast(response, 'Formula created successfully');
                this.formula = response.data;
            } catch (error) {
                showToast(error.response || error, 'Failed to create formula');
            }
        },

        async updateFormula(formula_id, body) {
            try {
                const response = await FormulaApi.updateFormula(formula_id, body);
                if (response.message == 'Ok') {
                    this.formula = response.data;
                    showToast(response, 'Formula updated successfully');
                    return true;
                }
            } catch (error) {
                showToast(error.response || error, 'Failed to update formula');
            }
        },

        async fetchFormulaById(formula_id, company_id) {
            try {
                const response = await FormulaApi.getFormulaById(formula_id, company_id);
                this.formula = response.data;
            } catch (error) {
                showToast(error.response || error, 'Failed to fetch formula by id');
            }
        },

        async deleteFormulaById(formula_id, company_id = null) {
            try {
                const response = await FormulaApi.deleteFormulaById(formula_id, company_id);
                if (response.message == 'Ok') showToast(response, 'Formula deleted successfully');
            } catch (error) {
                showToast(error.response || error, 'Failed to delete formula');
            }
        },

        async exportCompanyToShared(formula_id, company_id) {
            try {
                const response = await FormulaApi.exportCompanyToShared(formula_id, company_id);
                // may or maynot be needed, change as needed
                this.formula = response.data;
            } catch (error) {
                showToast(error.response || error, 'Failed to export formula to shared library');
            }
        },

        async importSharedToCompany(formula_id, company_id) {
            try {
                const response = await FormulaApi.importSharedToCompany(formula_id, company_id);
                // may or maynot be needed, change as needed
                this.formula = response.data;
            } catch (error) {
                showToast(error.response || error, 'Failed to import formula to company library');
            }
        },

        async testFormula(body) {
            try {
                const response = await FormulaApi.testFormula(body);
                if (response.message == 'Ok') {
                    showToast(response, 'Formula is valid');
                    return true;
                }
                return false;
            } catch (error) {
                showToast(error.response || error, 'Failed to test formula');
            }
        },
    },
});
